import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    const scrollToAbout = () => {
        const aboutSection = document.querySelector('#about');
        if (aboutSection) {
            const offsetTop = aboutSection.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="hero" id="home">
            <div className="hero-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>
            <div className="hero-content">
                <div className="hero-text" data-scroll-reveal>
                    <p className="hero-greeting">Hello, I'm</p>
                    <h1 className="hero-title">
                        <span className="title-line">Creative</span>
                        <span className="title-line">Designer &</span>
                        <span className="title-line">Developer</span>
                    </h1>
                    <p className="hero-description">
                        Crafting digital experiences that blend aesthetics with functionality.
                        Specializing in web design, UI/UX, and front-end development.
                    </p>
                    <div className="hero-cta">
                        <Link to="/work" className="btn btn-primary">View My Work</Link>
                        <a href="#contact" className="btn btn-secondary">Get In Touch</a>
                    </div>
                </div>
            </div>
            <div className="scroll-indicator" onClick={scrollToAbout} style={{ cursor: 'pointer' }}>
                <div className="mouse">
                    <div className="wheel"></div>
                </div>
                <p>Scroll to explore</p>
            </div>
        </section>
    );
};

export default Hero;
